import { Component, OnInit, Input, TemplateRef, ViewChild, ElementRef, HostListener, Renderer2, NgZone, Output, EventEmitter } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Subscription, BehaviorSubject } from 'rxjs';
import * as Hammer from 'hammerjs';
import { PlatformService } from 'src/app/services/platform.service';
import { RegisterIconsService } from 'src/app/services/register-icons.service';

@Component({
	selector: 'lista-scrolling',
	templateUrl: './lista-scrolling.component.html',
	styleUrls: ['./lista-scrolling.component.scss']
})
export class ListaScrollingComponent implements OnInit {

	@ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport;
	@Input('template') templateRef: TemplateRef<any>; //template é o item que será renderizado no for
	@Input('templateActions') templateActionsRef: TemplateRef<any>; //template é o item que será renderizado no for
	@Input('listaItems') listaItems: Array<any> = []; //lista de itens
	@Input('notPull') notPull: boolean = false; //lista de itens
	@Input('slidingItem') slidingItem: boolean = false; //lista de itens
	@Input('maxWidth') maxWidth: boolean = false; // Ocupar toda largura da tela

	loadingUpdateLista: boolean = false; //se esta carregando a lista
	pullReloadingAnimation: 'initial' | 'hide' | 'show' = 'show'; //animação de loading

	//emitir o evento para atualizar a lista
	@Output('updateLista') updateLista = new EventEmitter();
	//emitir que esta sendo atualizado
	@Output('updating') updating = new EventEmitter();
	//emitir click submenu
	@Output('eventClickSubMenu') eventClickSubMenu = new EventEmitter();


	/** VARIAVEIS TOUCH PULL REFRESH */
	@ViewChild('pullRefresh', { static: true }) pullRefresh: ElementRef;
	distance = 0;
	lastPosY = 0;
	positionListTop = 0;
	page = 1;//usado para buscar requisição
	theEnd: boolean = false;
	movingList: boolean = false; //não deixar abrir modal/page se estiver movendo/gesture na lista	
	

	subscriptions: Subscription = new Subscription();
	offset = new BehaviorSubject(null);

	constructor(
		public platformService: PlatformService,
		private icons: RegisterIconsService,
		public render: Renderer2,
		public ngZone: NgZone,
	) {
		icons.registerIcons(['archive-arrow-up'])
	}

	/** SE REDIMENCIONAR A TELA GARANTE QUE O BOX DA LISTA ESTEJA SEMPRE PROPORCIONAL */
	@HostListener('window:resize', ['$event'])
	onResize(event) {
		if (this.viewPort) {
			this.viewPort.checkViewportSize();
		}
	}

	ngOnInit(): void {
		let containerPage = document.querySelector('.container-page');
		this.render.setStyle(containerPage, 'overflow', 'hidden');

		// let _this = this;		
		// let container = this.pullRefresh.nativeElement;

		// if (this.platformService.virtualDeviceType != 'desktop') {
		// 	container.addEventListener('touchstart', this.touchStart);
		// 	container.addEventListener('touchmove', this.touchMove);
		// 	container.addEventListener('touchend', this.touchEnd);
		// } else {
			// let swipe = new Hammer(container);
			// swipe.get('pan').set({ direction: Hammer.DIRECTION_DOWN });

			// swipe.on("panmove panend", function (e) {			
			// 	if(!_this.notPull){
			// 		if (_this.positionListTop == 0 && e.distance < 90 && e.type == 'pandown') {
			// 			_this.movingList = true;
			// 			container.style.transition = '0s';
			// 			container.style.transform = `translateY(${e.distance}px)`;
			// 			_this.pullReloadingAnimation = 'show';
			// 			_this.updating.emit(true);
			// 		}
					
			// 		if (e.type == 'panend') {
			// 			if (_this.movingList) {
			// 				container.style.transition = '.4s';
			// 				container.style.transform = 'translateY(0)';
			// 				setTimeout(() => {
			// 					_this.movingList = false;
			// 					_this.page = 1;//usado para buscar requisição
			// 					_this.theEnd = false;
			// 					_this.loadingUpdateLista = false;
			// 					_this.emitUpdateLista();
			// 				})
			// 			}
			// 		}
			// 	}
			// });
		// }		
	}

	panMove(e){
		if(!this.notPull){
			let container = this.pullRefresh.nativeElement;
			if (this.positionListTop == 0 && e.distance < 90 && e.additionalEvent == 'pandown') {
				this.movingList = true;
				container.style.transition = '0s';
				container.style.transform = `translateY(${e.distance}px)`;
				this.pullReloadingAnimation = 'show';
				this.updating.emit(true);
			}
		}
	}

	panend(e){	
		if (this.movingList) {
			let container = this.pullRefresh.nativeElement;
			container.style.transition = '.4s';
			container.style.transform = 'translateY(0)';
			setTimeout(() => {
				this.movingList = false;
				this.page = 1;//usado para buscar requisição
				this.theEnd = false;
				this.loadingUpdateLista = false;
				this.emitUpdateLista();
			})
		}
	}

	ngAfterViewInit() {
		this.subscriptions.add(this.viewPort.elementScrolled().subscribe(() => {
			this.positionListTop = this.viewPort.measureScrollOffset('top');
			const posBottom = this.viewPort.measureScrollOffset('bottom');

			if (this.theEnd) return;
			if (!this.loadingUpdateLista && posBottom < 80) {
				this.pullReloadingAnimation = 'show';
				this.page++;//usado para buscar requisição
				this.loadingUpdateLista = true;
				this.emitUpdateLista(true, this.offsetBatch);
			}
		}))
	}

	/** EVENTOS DE TOUCH MOBILE */
	lastTouchX;
	touchStart = (ev) => {
		if(!this.notPull){
			this.lastPosY = ev.touches[0].clientY;
			this.lastTouchX = ev.touches[0].clientX;
		}
	}
	touchMove = (ev) => {
		console.log('ev move', ev);
		if(!this.notPull){
			let container = this.pullRefresh.nativeElement;
			this.render.setStyle(container, 'transition', 'none');
			let currentPos = ev.changedTouches[0].clientY;
			let currentTouchX = ev.changedTouches[0].clientX;
			this.distance += 2;
		
			console.log('ev.changedTouches[0]', ev.changedTouches[0]);
			// console.log('currentPos', currentPos);
			
			if (this.lastPosY < currentPos && this.positionListTop == 0 && this.distance < 90) {
				this.movingList = true;
				this.render.setStyle(container, 'transform', `translateY(${this.distance}px)`);
				this.pullReloadingAnimation = 'show';
				this.updating.emit(true);
				ev.preventDefault();
			}
			this.lastPosY = currentPos;
		}
	}
	touchEnd = (ev) => {
		if(!this.notPull){
			this.lastPosY = 0;
			this.distance = 0;
			if (this.movingList) {
				let container = this.pullRefresh.nativeElement;
				this.render.setStyle(container, 'transition', '.4s');
				this.render.setStyle(container, 'transform', `translateY(0px)`);
				
				this.movingList = false;
				this.page = 1; //usado para buscar requisição
				this.theEnd = false;
				this.loadingUpdateLista = false;
				this.emitUpdateLista();
			}
		}
	}
	/** FIM EVENTOS DE TOUCH MOBILE */


	/** EMITIR EVENTO PARA ATUALIZAR A PÁGINA */
	emitUpdateLista(next?, offset?){
		this.updateLista.emit({page: this.page, next, offset});
	}
	
	/** CALCULA ALTURA DO CARD CONFORME NÚMERO DE ITENS */
	calcHeight(num, opt?) {
        let elemento: any = this.pullRefresh.nativeElement;
		let calculoAltura = num * 64;
		if(elemento && window.innerHeight > calculoAltura) {
			this.render.setStyle(elemento, 'height', calculoAltura + 'px');
        } else if(opt) {
			this.render.setStyle(elemento, 'height','calc(100% - 52px)');
		} else{
			this.render.setStyle(elemento, 'height','100%');
		}
	}
	
	/** Emite quando o índice do primeiro elemento visível na janela de visualização é alterado/some da tela.
	 * OFFSET recebe sempre o último elemento do array para saber quando vai ficar visivel na view e poder chamar
	 * as funções para atualizar a lista
	 */
	offsetBatch;
	nextBatch(e, offset?) {
		this.offsetBatch = offset;
	}

	/** Emite click do submenu */
	clickSubMenu(ev){
		this.eventClickSubMenu.emit(ev);
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
		if (this.platformService.virtualDeviceType != 'desktop') {
            let container = this.pullRefresh.nativeElement;
            container.removeEventListener('touchstart', this.touchStart);
            container.removeEventListener('touchmove', this.touchMove);
            container.removeEventListener('touchend', this.touchEnd);
		}	
		let containerPage = document.querySelector('.container-page');
		this.render.setStyle(containerPage, 'overflow', 'auto');	
	}

}
